import { render, staticRenderFns } from "./InitialContracts.vue?vue&type=template&id=734c0ba6&scoped=true"
import script from "./InitialContracts.vue?vue&type=script&lang=js"
export * from "./InitialContracts.vue?vue&type=script&lang=js"
import style0 from "./InitialContracts.vue?vue&type=style&index=0&id=734c0ba6&prod&lang=scss&scoped=true"
import style1 from "./InitialContracts.vue?vue&type=style&index=1&id=734c0ba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734c0ba6",
  null
  
)

export default component.exports